export default __webpack_public_path__ + "static/media/emma-testimonial.a56d7ab7.png";